module.exports = __webpack_public_path__ + "img/placeholder.284119c3.jpg";